














































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { getImgServer, loginServe, processServe } from '@/api/installServer';
import ShuttleChildernBox from '@/components/shuttleBox/shuttleChildernBox.vue';

@Component({
  components: { ShuttleChildernBox },
})
export default class DealWithDrawer extends Vue {
  private visible = false;
  flowDataHandle: any = {};
  btn_file: any;

  formData: any = {
    number: '202108200937000290531',
    name: '张三',
    company: '杭州祺云科技有限公司',
    department: '技术部',
    makeUpCardShift: '2021/08/20，星期五，中班，下班时间18:00',
    makeUpCardTime: '2021-8-20 18:00',
    makeUpCardReason: '补卡路由',
    approvalComments: '',
    agreeList: [],
    // agreeList: [
    //   { objId: '1', objName: '王武' },
    //   { objId: '2', objName: '臧三' },
    //   { objId: '3', objName: '李斯' },
    // ], // 同意人员列表
    // imgList: ['https://img2.baidu.com/it/u=1969982897,3857962108&fm=26&fmt=auto&gp=0.jpg', 'https://img0.baidu.com/it/u=1625981895,2179496145&fm=26&fmt=auto&gp=0.jpg'], // 图片列表
    imgList: [],
    fileList: [],
    // fileList: [
    //   {
    //     fileName: '文件名.后缀1',
    //     fileSize: '5.93MB',
    //   },
    //   {
    //     fileName: '文件名.后缀2',
    //     fileSize: '5.93MB',
    //   },
    // ],
    processList: [
      {
        type: 0,
        processTitle: '发起申请',
        processName: '张三',
        processTime: '08/23 08:56',
      },
      {
        type: 3,
        processTitle: '直接主管',
        processName: '李四',
        processTime: '08/24 08:56',
      },
    ],
  };

  colorList = ['#4C64FE', '#32C5FF', '#6236FF'];
  form: any = {};
  staffIndex: any;

  get deptTree() {
    return this.$store.state.user.deptTree;
  }

  mounted() {}

  getFlowLog(item: any) {
    processServe
      .getFlowExampleLog(item.id)
      .then((res: any) => {
        console.log(res.data);
        this.formData.processList = res.data;
      })
      .catch((e: any) => {});
  }

  choseStaff(index: any, item: any) {
    if (item.auth === 'READ') {
      this.$notify.error({
        title: '提示',
        message: '无编辑权限',
        showClose: false,
      });
      return false;
    }
    // 打开只有部门下级人员的审批弹出框
    // const data = this.choseStaffList || [];
    const shuttleChildrenBox = 'shuttleChildrenBox';
    this.staffIndex = index;
    const shuttleChildrenBoxComponent = this.$refs[shuttleChildrenBox];
    (shuttleChildrenBoxComponent as any).showDialog(this.flowDataHandle.formControlList[index].valueObj);
  }

  checkChildrenNodeData(data: any) {
    // this.flowDataHandle.formControlList[this.staffIndex].valueObj = data;
    console.log(data);
    this.$set(this.flowDataHandle.formControlList[this.staffIndex], 'valueObj', data);
    console.log(this.flowDataHandle);
  }

  checkFollow(data: any) {
    const shuttleChildrenBox = 'shuttleFollowBox';
    const shuttleChildrenBoxComponent = this.$refs[shuttleChildrenBox];
    (shuttleChildrenBoxComponent as any).showDialog();
  }

  checkFollowBack(data: any) {
    this.$set(this.formData, 'agreeList', data);
  }

  /**
   * @desc 弹窗显示的函数
   */
  private async showDrawer(form: any, flowDataHandle: any) {
    this.formData.approvalComments = '';
    this.getFlowLog(form);
    this.form = form;
    console.log(this.form);

    this.flowDataHandle = flowDataHandle;
    this.flowDataHandle.formControlList.forEach((item: any, index: any) => {
      if (item.componentName === 'ContactPerson') {
        const arr: any = item.value.split(',');
        const objArr: any = [];
        arr.forEach((staff: any) => {
          objArr.push({
            objName: this.idToName(staff, 'staff'),
            objId: staff,
          });
        });
        this.flowDataHandle.formControlList[index].valueObj = objArr;
      }
    });
    console.log(this.flowDataHandle);
    this.visible = true;
  }

  idToName(id: any, type: any) {
    const arr: any = [];
    let name: any = '';
    if (type === 'staff') {
      this.deptTree.forEach((dept: any) => {
        dept.staffList.forEach((staff: any) => {
          if (id === staff.staffId) {
            name = staff.staffName;
          }
        });
      });
    }
    if (type === 'dept') {
      this.deptTree.forEach((dept: any) => {
        if (id === dept.id) {
          name = dept.name;
        }
      });
    }
    return name;
  }

  /**
   * @desc 点击弹窗之外的地方隐藏
   */
  handleClose() {
    this.visible = false;
  }

  /**
   * @desc 上传图片
   */
  upPicture() {
    (document.getElementById('btn_img') as HTMLElement).click();
    this.btn_file = document.getElementById('btn_img') as HTMLElement;
  }

  /**
   * @desc 上传文件
   * @todo
   */
  upFile() {
    (document.getElementById('btn_file') as HTMLElement).click();
    this.btn_file = document.getElementById('btn_file') as HTMLElement;
  }

  /**
   * @desc 图片发生变化
   */
  changePic1(e: any) {
    let src = '';
    if (e.target.nodeName == 'INPUT') {
      const file = e.target.files[0];
      console.log(file);
      if (file.type.indexOf('image') > -1) {
        src = window.URL.createObjectURL(file);
      }
    }
    if (src) {
      const file = e.target.files[0];
      const param = new FormData();
      param.append('file', file);
      // 图片上传
      getImgServer
        .putImg(param)
        .then((res: any) => {
          const result = res.data || {};
          if (res.code !== '201') {
            this.$message.warning(result.msg);
          } else {
            // 上传成功
            this.formData.imgList.push({
              src: src,
              item: e.target.files[0],
              id: result[0].id,
            });
            this.$forceUpdate();
          }
          if (result.data) {
            console.log(res.data);
          }
        })
        .catch((e: any) => {
          console.log(e);
        });
    }
  }

  /**
   * @desc 文件发生变化
   */
  changePic2(e: any) {
    let filename = '';
    let fileSize1: any;
    let fileSize2: any;
    if (e.target.nodeName == 'INPUT') {
      const file = e.target.files[0];
      if (file.type.indexOf('application') > -1 || file.type.indexOf('txt') > -1) {
        filename = file.name;
        fileSize1 = (file.size / 1000).toFixed(2);
        if (fileSize1 < 1000) {
          fileSize2 = fileSize1 + 'KB';
        } else {
          fileSize2 = (fileSize1 / 1000).toFixed(2) + 'MB';
        }
      }
    }
    if (filename) {
      this.formData.fileList.push({
        fileName: filename,
        fileSize: fileSize2,
        item: e.target.files[0],
      });
      this.$forceUpdate();
    }
  }

  /**
   * @desc 点击叉号移除图片
   */
  removePic(n: number) {
    this.formData.imgList.splice(n, 1);
    this.$forceUpdate();
  }

  /**
   * @desc 点击叉号移除文件
   */
  removeFile(index: number) {
    this.formData.fileList.splice(index, 1);
    this.$forceUpdate();
  }

  agree(approveStatus: any) {
    const map: any = {};
    this.flowDataHandle.formControlList.forEach((item: any) => {
      map[item.props.id] = item.value;
    });

    const addList: any = [];
    this.formData.agreeList &&
      this.formData.agreeList.forEach((item: any) => {
        addList.push({
          staffId: item.objId,
          staffName: item.objName,
        });
      });

    const imgArr: any = [];
    this.formData.imgList &&
      this.formData.imgList.forEach((item: any) => {
        imgArr.push(item.id);
      });

    const a = {
      controlValueMap: {
        additionalProp1: 'string',
        additionalProp2: 'string',
        additionalProp3: 'string',
      },
      exampleApprove: {
        addSignatureStaff: [
          {
            staffId: 'string',
            staffName: 'string',
          },
        ],
        approveStatus: false,
        content: 'string', // 意见
        images: 'string',
        signature: 'string', // 签名
      },
      exampleHandle: {
        // 处理实例
        content: 'string',
        images: 'string',
      },
      handler: 'string',
    };
    let obj: any;
    if (this.flowDataHandle.operateWay === 'approve') {
      obj = {
        controlValueMap: map,
        exampleApprove: {
          approveStatus: approveStatus,
          // addSignatureStaff: addList, // 加签
          content: this.formData.approvalComments,
          images: imgArr.toString(),
        },
      };
    }
    if (this.flowDataHandle.operateWay === 'handle') {
      obj = {
        controlValueMap: map,
        exampleHandle: {
          // 处理实例
          content: this.formData.approvalComments,
          images: imgArr.toString(),
        },
      };
    }

    console.log(obj);

    processServe
      .handleFlowExample(obj, this.flowDataHandle.id)
      .then((res: any) => {
        console.log(res.data);
        if (res.code === '200') {
          this.visible = false;
          this.$emit('back');
        }
      })
      .catch((e: any) => {});
  }
}
